import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'pt_PT',
  {
    fdidYouMean: true,
    ffacetNavigation: true,
    fdomainSuggestions: true,
    fvideo: true,
    fCommerceCarrossel: true,
    resultTiles: true,
    dealerWidget: true,
    frelatedsearch: true,
  },
  {
    fssInputCategory: true,
  },
  '6f037918-457f-4bae-8085-93d26d9ed96f',
  ''
);
